document.addEventListener('DOMContentLoaded', function () {
    // Main elements
    const toggle = document.querySelector('.mobile-menu-toggle');
    const menu = document.querySelector('.mobile-menu');
    const menuItems = document.querySelectorAll('.mobile-menu-item');
    const backButtons = document.querySelectorAll('.mobile-menu-back-link');
    const closeButton = document.querySelector('.mobile-menu-close');
    const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
    

    // Main event listeners
    if (toggle && menu) {
        toggle.addEventListener('click', openMobileMenu);
        closeButton.addEventListener('click', closeMobileMenu);
        mobileMenuOverlay.addEventListener('click', closeMobileMenu);
    }

    // Setup menu item navigation
    setupMenuItemNavigation(menuItems);
    setupBackButtons(backButtons);

    // Setup additional interactions
    setupKeyboardNavigation();
    setupTouchGestures();

    // Helper functions
    function openMobileMenu() {
        menu.classList.add('is-open', 'is-active');
        mobileMenuOverlay.classList.add('is-active');
        toggle.classList.add('active');
    }

    function closeMobileMenu() {
        menu.classList.remove('is-open', 'is-active');
        mobileMenuOverlay.classList.remove('is-active');
        toggle.classList.remove('active');
    }

    function setupMenuItemNavigation(items) {
        items.forEach(item => {
            item.addEventListener('click', function (e) {
                if (!e.target.closest('a')) {
                    e.preventDefault();
                }
                const subMenu = this.querySelector('.mobile-menu-level');
                const currentMenu = this.closest('.mobile-menu-level');
                if (subMenu && currentMenu) {
                    subMenu.classList.add('is-visible');
                }
            });
        });
    }

    function setupBackButtons(buttons) {
        buttons.forEach(button => {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                const currentMenu = this.closest('.mobile-menu-level');
                const parentMenu = currentMenu.parentElement.closest('.mobile-menu-level');
                if (currentMenu && parentMenu) {
                    currentMenu.classList.remove('is-visible');
                }
            });
        });
    }

    function setupKeyboardNavigation() {
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && menu.classList.contains('is-open')) {
                closeMobileMenu();
            }
        });
    }

    function setupTouchGestures() {
        let touchStartX = 0;
        let touchEndX = 0;

        document.body.addEventListener('touchstart', function(e) {
            touchStartX = e.changedTouches[0].screenX;
        }, false);

        document.body.addEventListener('touchend', function(e) {
            touchEndX = e.changedTouches[0].screenX;
            if (touchEndX - touchStartX > 50) { // Swipe right (close menu)
                closeMobileMenu();
            }
        }, false);
    }
});